<div class="modal-overlay">
    <div class="modal-content">
        <div class="align-headers">
            <div class="header">
                <img src="../../../assets/images/cross_icon_grey.svg" alt="close" tabindex="0" mat-dialog-close="0" (click)="closeQrCodeHandler()" (keydown.enter)="closeQrCodeHandler()" (keydown.space)="closeQrCodeHandler()">
            </div>
            <div class="heading-box">
                <div class="first-letter">{{ metaData.name.charAt(0) }}</div>
                <span class="reference">{{metaData.reference}}</span>
                <span class="title">{{metaData.name}}</span>
                <span class="amount">&#8364;{{(metaData.amount)|convertWithDecimal:selectedVehicle:false:false:''}}</span>
            </div>
        </div>
        <div *ngIf="status === 'paid'" class="code-description">
            <span class="paid-topic">
                <img src="../../../../assets/images/circle_green_tick.svg" alt=" " class="src">
                Payment Confirmed
            </span>
            <p class="paid-details">
                <span>Ref no: {{metaData.reference}}</span>
                <span>Date: {{ metaData.timestamp | date:'d MMMM, y h:mm a' }}</span>
            </p>
        </div>
        <mat-tab-group animationDuration="0ms" class="qr-tab-group">
            <mat-tab label="QR Code">
                <div class="qrcode-container">
                    <div class="qr-code-img">
                        <img class="qr-code" *ngIf="qrCodeBase64" [src]="qrCodeBase64" alt="EPC QR Code">
                    </div>
                    <p  *ngIf="status !== 'paid'"class="qr-subtitle">Scan this QR code on your banking app to pay</p>
                    <p  *ngIf="status === 'paid' || status === 'rejected'" class="qr-subtitle"><b>Payment not processed?</b> Scan this QR code in your banking app to retry the payment.</p>
                </div>
            </mat-tab>
            <mat-tab label="Details">
                <div class="qrcode-details-section">
                    <div class="qrcode-detail">
                       <p>
                        <span class="key">Account name</span>
                        <span class="value">{{metaData.name}}</span>
                       </p> 
                       <button class="copy-circle" (click)="clipboardCopy(metaData.name)">
                        <img src="assets/images/copy_icon.svg" height="24px" width="24px" alt="Icon">
                       </button>
                    </div>
                    <div class="qrcode-detail">
                        <p>
                         <span class="key">IBAN</span>
                         <span class="value">{{metaData.iban}}</span>
                        </p> 
                        <button class="copy-circle" (click)="clipboardCopy(metaData.iban)">
                         <img src="assets/images/copy_icon.svg" height="24px" width="24px" alt="Icon">
                        </button>
                     </div>
                     <div class="qrcode-detail">
                        <p>
                         <span class="key">SWIFT/BIC</span>
                         <span class="value">{{metaData.bic}}</span>
                        </p> 
                        <button class="copy-circle" (click)="clipboardCopy(metaData.bic)">
                         <img src="assets/images/copy_icon.svg" height="24px" width="24px" alt="Icon">
                        </button>
                     </div>
                </div>
            </mat-tab>
        </mat-tab-group>
        <div *ngIf="status === 'ready_for_payment' || status === 'partially_paid' && !isReadyOnly" class="footer-container">
            <button class="btn btn-primary" (click)="markAsPaidHandler()">I have made the transfer</button>
            <button class="btn btn-secondary" (click)="closeQrCodeHandler()">I will do it later</button>
        </div>
    </div>
</div>